import { useBreakpointComposable } from '@bt/design-system'
import { ref } from 'vue'
import type { Ref } from 'vue'

export const useBreakpoints = (): { isMobile: Ref; isTablet: Ref; isDesktop: Ref } => {
  if (process.client) {
    const { isMobile, isTablet, isDesktop } = useBreakpointComposable()

    return {
      isMobile,
      isTablet,
      isDesktop
    }
  }

  return {
    isMobile: ref(false),
    isTablet: ref(false),
    isDesktop: ref(false)
  }
}
